import { Component, Input } from '@angular/core';

@Component({
  selector: 'nav-arrow-right',
  standalone: true,
  imports: [],
  templateUrl: './nav-arrow-right.component.html',
  styleUrl: './nav-arrow-right.component.scss',
})
export class NavArrowRightComponent {
  @Input() icon = 'chevron_right';

  open(ev: any): void {
    const $btn = ev.currentTarget as HTMLElement;
    const $subMenu = $btn.closest('.js-menu-item')?.querySelector('.js-menu-list');

    $subMenu && $subMenu.classList.toggle('is-active');
  }
}
